// hooks/useLiveConnectionData.js
import { useState, useEffect } from 'react';
import { useGetLiveConnectionStats } from '../app/useGetLiveConnectionStats';

export const useLiveConnectionStats = (locationSelection) => {
  const [liveConnectionPayload, setLiveConnectionPayload] = useState(null);
  const [liveConnectionStat, setLiveConnectionStat] = useState({
    title: "Guests connected",
    value: 0,
  });

  useEffect(() => {
    if (locationSelection && locationSelection.length > 0) {
      // Prepare payload for fetching live connection stats
      setLiveConnectionPayload({
        timestamp: Date.now(),
        request_type: "live-connections-metrics",
        payload: {
          location_ids: locationSelection,
        },
      });
    } else {
      // Reset payload if no locations selected
      setLiveConnectionPayload(null);
      // Reset stat to 0 when no locations
      setLiveConnectionStat({
        title: "Guests connected",
        value: 0,
      });
    }
  }, [locationSelection]);

  const { data: liveConnectionStats } = useGetLiveConnectionStats(liveConnectionPayload);

  useEffect(() => {
    if (liveConnectionStats) {
      const liveData = liveConnectionStats.data.data;
      setLiveConnectionStat(
        {
          title: "Guests connected",
          value: liveData.live_connections,
        }
      );
    }
  }, [liveConnectionStats]);

  // Update live stats every 30 seconds (only if locations are selected)
  useEffect(() => {
    if (!locationSelection || locationSelection.length === 0) {
      return; // Don't set up interval if no locations
    }

    const intervalId = setInterval(() => {
      setLiveConnectionPayload(prevPayload => {
        // Only update if we have a valid previous payload
        if (!prevPayload) return prevPayload;
        
        return {
          ...prevPayload,
          timestamp: Date.now(),
        };
      });
    }, 30000);

    return () => clearInterval(intervalId);
  }, [locationSelection]);

  return {
    liveConnectionStat,
  };
};